import React, { useState } from "react";
import "../../styles/OrderTimeline.css";
import { formatDate } from "../../App";
import { Truck } from "react-feather";

const OrderLine = ({ selectedItem }) => {
  const [hoveredStep, setHoveredStep] = useState(null);
  const [showAll, setShowAll] = useState(false);

  const timelineSteps = [
    { 
      key: "orderedAt", 
      label: "Order Confirmed", 
      date: selectedItem.orderedAt, 
      icon: "✓", 
      description: "Your order has been confirmed" 
    },
    { 
      key: "packedAt", 
      label: "Packed", 
      date: selectedItem.packedAt, 
      icon: "📦", 
      description: "Order has been packed and ready" 
    },
    { 
      key: "shippedAt", 
      label: "Shipped", 
      date: selectedItem.shippedAt, 
      icon: <Truck />, 
      description: "Order is on the way" 
    },
    { 
      key: "deliveredAt", 
      label: "Delivered", 
      date: selectedItem.deliveredAt, 
      icon: "✓", 
      description: "Order delivered successfully" 
    },
  ];

 const status = (selectedItem.status || "").toLowerCase();

let defaultSteps = [];

if (status === "ordered") {
  defaultSteps = ["orderedAt"];
} 
else if (status === "packed") {
  defaultSteps = ["orderedAt", "packedAt"];
} 
else if (status === "shipped") {
  defaultSteps = ["orderedAt", "shippedAt"];
} 
else if (status === "delivered") {
  defaultSteps = ["orderedAt", "deliveredAt"];
}

const visibleSteps = showAll
  ? timelineSteps
  : timelineSteps.filter(step => defaultSteps.includes(step.key));

  return (
    <div className="order-timeline-container">
      <h3 className="timeline-title">Order Status</h3>
      <div className="timeline-wrapper">
        {visibleSteps.map((step, index) => {
          const completed = !!step.date;
          const hovered = hoveredStep === index;

          return (
            <div
              key={step.key}
              className={`timeline-step ${completed ? "completed" : ""} ${hovered ? "hovered" : ""}`}
              onMouseEnter={() => setHoveredStep(index)}
              onMouseLeave={() => setHoveredStep(null)}
            >
              <div className={`timeline-dot ${completed ? "completed" : ""} ${step.date ? "has-date" : ""}`}>
                {completed ? <span className="dot-icon">{step.icon}</span> : <span className="dot-pending"></span>}
                {completed && <div className="dot-ripple"></div>}
              </div>
              {index < visibleSteps.length - 1 && <div className={`timeline-line ${completed ? "completed" : ""}`} />}
              <div className="timeline-content">
                <div className="timeline-header">
                  <span className="step-label">{step.label}</span>
                  {step.date && <span className="step-date">{formatDate(step.date)}</span>}
                </div>
                {completed && hovered && step.description && <div className="step-description">{step.description}</div>}
                {completed && (
                  <div className="completion-badge">
                    <i className="check-icon">✓</i>
                    <span>Completed</span>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
      <div style={{ textAlign: "center", marginTop: 20 }}>
        <button className="btn btn-outline-primary fs-4" onClick={() => setShowAll(!showAll)}>
          {showAll ? "View Less" : "View More"}
        </button>
      </div>
    </div>
  );
};

export default OrderLine;